import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

export const FieldLabel = ({
  htmlFor,
  children,
  className,
}: {
  htmlFor?: string;
  children: ReactNode;
  className?: string;
}) => (
  <label
    htmlFor={htmlFor}
    className={cn('mb-label block text-meta font-medium text-muted', className)}
  >
    {children}
  </label>
);
